import { render, staticRenderFns } from "./complete-registration-modal.vue?vue&type=template&id=33f649a4&scoped=true"
import script from "./complete-registration-modal.vue?vue&type=script&lang=js"
export * from "./complete-registration-modal.vue?vue&type=script&lang=js"
import style0 from "./complete-registration-modal.vue?vue&type=style&index=0&id=33f649a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f649a4",
  null
  
)

export default component.exports